import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';

const VerifyEmailSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email') || 'your email';
    const alreadyVerified = queryParams.get('alreadyVerified') === 'true';

    if (alreadyVerified) {
      setMessage(`Your email (${email}) is already verified. Please proceed to log in.`);
    } else {
      setMessage(`Your email (${email}) has been successfully verified! You can now proceed to log in.`);
    }

    const timer = setTimeout(() => {
      navigate('/login', { replace: true });
    }, 10000); // Keep 10s timeout as per your latest code

    return () => clearTimeout(timer);
  }, [navigate, location.search]);

  return (
    <div className="verify-email-container">
      <FaCheckCircle className="success-icon" />
      <h2>Email Verification</h2>
      <p>{message}</p>
      <button onClick={() => navigate('/login')}>Go to Login</button>

      <style>{`
        .verify-email-container {
          max-width: 600px;
          margin: 2rem auto;
          padding: 2rem;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          text-align: center;
        }
        .success-icon {
          color: #28a745;
          font-size: 3rem;
          margin-bottom: 1rem;
        }
        h2 {
          color: #333;
          margin-bottom: 1.5rem;
        }
        p {
          color: #555;
          font-size: 1rem;
          margin-bottom: 2rem;
        }
        button {
          padding: 0.75rem 1.5rem;
          background: #fa4848;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 1rem;
          cursor: pointer;
        }
        button:hover {
          background: #e03e3e;
        }
        html[data-theme="dark"] .verify-email-container {
          background: #1e1e1e;
          box-shadow: 0 2px 10px rgba(0,0,0,0.4);
        }
        html[data-theme="dark"] h2 {
          color: #f0f0f0;
        }
        html[data-theme="dark"] p {
          color: #bbb;
        }
      `}</style>
    </div>
  );
};

export default VerifyEmailSuccess;